<template>

  <div  >



     <b-table-simple small borderless caption-top responsive >
        <caption class="font-weight-bold">System status</caption>

        <b-tbody>
          <b-tr> <b-th>Last online: </b-th> <b-td> {{ last_online }} </b-td> </b-tr>
          <b-tr> <b-th>Battery status:  </b-th> <b-td>  </b-td> </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-progress height="80px" variant="success">
        <b-progress-bar  :value="currentValue" :label="`${currentValue}%`"></b-progress-bar>
      </b-progress>


      <div class="small">
        <line-chart class="chartClass_batt" :chart-data="datacollection" :options="options"></line-chart>
      </div>

  </div>
</template>

<script>



import LineChart from './LineChart.js'

 export default {
   name: 'Battery',
   components: {
      LineChart
    },

   data: function (){
     return {
       options: {
          responsive: true,
          maintainAspectRatio: false,
          scales : {
            xAxes: [{
              type: 'time',
              time: {
                  displayFormats: {
                      quarter: 'MMM D'
                  }
              }
              }],
            yAxes: [{
              ticks : {
                beginAtZero : true,
                stepSize : 10, 
                suggestedMax : 100
              },
          }],
          },
          legend: {
            display : false
          }
        },
     }
   },
    props: {
     datacollection:  {
      type: Object,
      required: true,
     }, 
     last_online:  {
      type: String,
      required: true,
     }, 
     currentValue : {
       type : Number, 
       required : true,
     }
   },
  
}

</script>

<style>

.chartClass_batt {
  max-height : 150px;
}


</style>
